<h1 id="paymentMethod" class="mb-4 text-lg font-bold text-gray-900 md:mb-6 md:text-2xl">Wybierz metodę płatności</h1>

<mat-radio-group [formControl]="paymentMethodControl" class="mb-6 flex flex-col gap-8">
  <div *ngIf="!!availableBillGatewayApps?.length">
    <h2 class="mb-3 font-semibold text-gray-900">Podłącz i opłacaj rachunki w banku lub aplikacji</h2>
    <div class="grid grid-cols-2 gap-2 sm:grid-cols-3 xl:gap-4">
      <div
        *ngFor="let availableBillGatewayApp of availableBillGatewayApps"
        class="relative z-20 method-wrapper"
        (mouseenter)="appHover.emit(true)"
        (mouseleave)="appHover.emit(false)"
        [class]="paymentMethodControl.value === availableBillGatewayApp.code ? 'method-active' : 'method-inactive'"
        (click)="paymentMethodControl.setValue(availableBillGatewayApp.code)"
      >
        <mat-radio-button
          class="flex w-full"
          [value]="availableBillGatewayApp.code"
          [checked]="paymentMethodControl.value === availableBillGatewayApp.code"
          [matTooltip]="availableBillGatewayApp.displayName"
        >
          <div class="absolute inset-0 m-4 ml-11 overflow-clip">
            <img
              [src]="'assets/img/apps/' + availableBillGatewayApp.code + '.png'"
              [alt]="availableBillGatewayApp.displayName"
              class="absolute top-0 right-0 bottom-0 left-0 h-full max-h-full w-full max-w-full object-contain"
            />
          </div>
        </mat-radio-button>
        <div
          *ngIf="availableBillGatewayApp.badge"
          class="absolute right-2 bottom-2 z-50 flex flex-row items-center gap-1 rounded rounded-full border px-2 border-success-200 bg-success-100 text-success-600 text-xxs py-0.5"
          [matTooltip]="availableBillGatewayApp.badge.tooltip"
        >
          <span class="uppercase leading-none">{{ availableBillGatewayApp.badge.label }}</span>
          <mat-icon *ngIf="availableBillGatewayApp.badge.icon" class="-mr-1 icon-12">{{
            availableBillGatewayApp.badge.icon
          }}</mat-icon>
        </div>
      </div>
    </div>
    <app-value-proposition
      class="md:flex lg:hidden"
      [highlight]="appHover || paymentMethodControl.isBillGatewayApp$ | async"
    ></app-value-proposition>
  </div>

  <div *ngIf="!!availablePaymentMethods?.length">
    <h2 class="mb-3 font-semibold text-gray-900">Inne metody płatności</h2>
    <div class="grid grid-cols-2 gap-2 xl:gap-4">
      <ng-container *ngFor="let availablePaymentMethod of availablePaymentMethods">
        <ng-container *ngTemplateOutlet="paymentMethodOutlet; context: availablePaymentMethod"></ng-container>
      </ng-container>
    </div>
  </div>
</mat-radio-group>

<ng-template
  #paymentMethodOutlet
  let-paymentMethod="paymentMethod"
  let-colSpan="colSpan"
  let-isGatewayApp="isGatewayApp"
>
  <div [ngClass]="' col-span-' + colSpan" class="relative col-span-2 sm:col-auto">
    <div
      class="relative z-20 method-wrapper"
      [class]="paymentMethodControl.value === paymentMethod ? 'method-active' : 'method-inactive'"
      (click)="setPaymentMethod(paymentMethod)"
    >
      <mat-radio-button
        class="flex w-full"
        [value]="paymentMethod"
        [checked]="paymentMethodControl.value === paymentMethod"
      >
        <ng-container *ngIf="paymentMethod === PaymentMethod.SIMP">
          <div class="ml-1 flex flex-row items-center whitespace-normal">
            <div class="flex flex-grow flex-col">
              <div class="text-base font-semibold text-gray-900 leading-2 sm:text-xs">
                Przelew tradycyjny
              </div>
              <div *ngIf="noCommissionLabelEnabled" class="text-xs text-primary-800/60">Bez prowizji</div>
            </div>
            <img
              class="mb-1 w-16"
              [src]="'assets/img/wire_transfer_' + CURRENT_THEME_HOLDER.currentTheme + '_sm.svg'"
              alt="Przelew tradycyjny"
            />
          </div>
        </ng-container>

        <ng-container *ngIf="paymentMethod === PaymentMethod.CARD">
          <div class="ml-1 whitespace-normal">
            <div class="flex flex-row">
              <div class="flex flex-grow flex-col justify-center">
                <div class="text-base font-semibold text-gray-900 leading-2 sm:text-xs">
                  Karta płatnicza
                </div>
              </div>
              <div class="flex w-16">
                <img class="self-center" src="assets/img/credit_cards.png" alt="Karty płatnicze" />
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="paymentMethod === PaymentMethod.TRANSFER">
          <div class="ml-1 flex flex-row items-center whitespace-normal">
            <div class="flex flex-grow flex-col">
              <div class="text-base font-semibold text-gray-900 leading-2 sm:text-xs">
                Szybki&nbsp;przelew&nbsp;/ transfer&nbsp;online
              </div>
            </div>
            <img
              class="mb-1 w-16"
              [src]="'assets/img/fast_transfer_' + CURRENT_THEME_HOLDER.currentTheme + '_sm.svg'"
              alt="Szybki przelew/transfer online"
            />
          </div>
        </ng-container>

        <ng-container *ngIf="paymentMethod === PaymentMethod.BLIK">
          <div class="ml-1 whitespace-normal">
            <div class="flex flex-row">
              <div class="flex flex-grow flex-col justify-center">
                <div class="text-base font-semibold text-gray-900 leading-2 sm:text-xs">
                  BLIK
                </div>
              </div>
              <div class="flex w-16">
                <img class="self-center" src="assets/img/blik.png" alt="Logo Blik" />
              </div>
            </div>
          </div>
        </ng-container>

        <!--        <ng-container *ngIf="paymentMethod === PaymentMethod.CARD_WITH_MU">-->
        <!--          <div class="ml-1 whitespace-normal">-->
        <!--            <div class="flex flex-row">-->
        <!--              <div class="flex flex-grow flex-col">-->
        <!--                <div-->
        <!--                  class="text-base font-semibold leading-5 leading-tight tracking-tight text-gray-900 whitespace-no-wrap"-->
        <!--                >-->
        <!--                  Karta płatnicza-->
        <!--                </div>-->
        <!--                <div *ngIf="payAppkaCommissionLabelEnabled" class="text-sm text-primary-600">-->
        <!--                  Prowizja {{ PAYAPPKA_COMMISSION | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}-->
        <!--                </div>-->
        <!--                <div *ngIf="couponAmount" class="text-sm font-semibold text-primary-600 whitespace-no-wrap">-->
        <!--                  Kupon: {{ couponAmount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              <div class="flex w-16 flex-col items-center justify-center">-->
        <!--                <img class="mb-1 self-center" src="assets/img/credit_cards.png" alt="Karty płatnicze" />-->
        <!--                <img class="self-center" src="assets/img/payappka_partner.png" alt="Logo PayAppka" />-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </ng-container>-->

        <!--        <ng-container *ngIf="paymentMethod === PaymentMethod.TWISTO">-->
        <!--          <div class="ml-1 whitespace-normal">-->
        <!--            <div class="flex flex-row">-->
        <!--              <div class="flex flex-grow flex-col">-->
        <!--                <div-->
        <!--                  class="text-base font-semibold leading-5 leading-tight tracking-tight text-gray-900 whitespace-no-wrap"-->
        <!--                >-->
        <!--                  Zapłać za 30 dni-->
        <!--                </div>-->
        <!--                <div *ngIf="payAppkaCommissionLabelEnabled" class="text-sm text-primary-600">-->
        <!--                  Prowizja {{ PAYAPPKA_COMMISSION | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}-->
        <!--                </div>-->
        <!--                <div *ngIf="couponAmount" class="text-sm font-semibold text-primary-600 whitespace-no-wrap">-->
        <!--                  Kupon: {{ couponAmount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              <div class="flex w-16 flex-col items-center justify-center">-->
        <!--                <img class="self-center" src="assets/img/twisto_logo.png" alt="Logo Twisto" />-->
        <!--                <img class="self-center" src="assets/img/payappka_partner.png" alt="Logo PayAppka" />-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </ng-container>-->

        <!--        <ng-container *ngIf="paymentMethod === PaymentMethod.PAY_BY_MU">-->
        <!--          <div class="ml-1 whitespace-normal">-->
        <!--            <div class="flex flex-row">-->
        <!--              <div class="flex flex-grow flex-col justify-center">-->
        <!--                <div class="text-base font-semibold leading-tight tracking-tight text-gray-900 whitespace-no-wrap">-->
        <!--                  Zapłać z PayAppką-->
        <!--                </div>-->
        <!--                <div *ngIf="payAppkaCommissionLabelEnabled" class="text-sm text-primary-600">-->
        <!--                  Prowizja {{ PAYAPPKA_COMMISSION | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}-->
        <!--                </div>-->
        <!--                <div *ngIf="couponAmount" class="text-sm font-semibold text-primary-600 whitespace-no-wrap">-->
        <!--                  Kupon: {{ couponAmount | currency: 'PLN':'symbol':'.2-2':'pl-PL' }}-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              <div class="w-28 md:self-center">-->
        <!--                <img src="assets/img/payappka_logo.svg" alt="Logo PayAppka" />-->
        <!--              </div>-->
        <!--            </div>-->

        <!--            <div class="mt-2 text-sm md:hidden">-->
        <!--              <div class="mb-2 leading-tight text-gray-700">-->
        <!--                Zyskaj przypomnienia, nowe metody płatności i więcej!-->
        <!--              </div>-->
        <!--              <ul>-->
        <!--                <li class="flex flex-row content-center text-primary-600 list-element">-->
        <!--                  <mat-icon class="mr-1 icon-20">check_circle_outline</mat-icon>-->
        <!--                  <span>Autopłatności</span>-->
        <!--                </li>-->
        <!--                <li class="text-primary-600 list-element">-->
        <!--                  <mat-icon class="mr-1 icon-20">check_circle_outline</mat-icon>-->
        <!--                  <span>Płatności zapisaną kartą</span>-->
        <!--                </li>-->
        <!--                <li class="text-primary-600 list-element">-->
        <!--                  <mat-icon class="mr-1 icon-20">check_circle_outline</mat-icon>-->
        <!--                  <span>Odraczania płatności o 30 dni</span>-->
        <!--                </li>-->
        <!--                <li class="text-primary-600 list-element">-->
        <!--                  <mat-icon class="mr-1 icon-20">check_circle_outline</mat-icon>-->
        <!--                  <span>Płatności jednym kliknięciem</span>-->
        <!--                </li>-->
        <!--              </ul>-->
        <!--              <div class="mb-1 text-sm leading-tight text-gray-700">-->
        <!--                i wiele więcej!-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </ng-container>-->
      </mat-radio-button>
    </div>
  </div>
</ng-template>
